// import React, { useRef } from 'react';
// import { Container, Typography, Grid, Paper, Box, Button } from '@mui/material';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import moment from 'moment/moment';
// import { useState, useEffect } from 'react';


// const BReport = ({ contentRef, DataObj }) => {
//     console.log("Data On Report ", DataObj);

//     return (
//         <div ref={contentRef}>
//             {/* <Paper style={styles.page} elevation={3}>
//                 <Container maxWidth="md">
//                     <Typography variant="h4" gutterBottom align="center">
//                         Booking Form
//                     </Typography>

//                     <Paper elevation={1} style={styles.section}>
//                         <Typography variant="h5" gutterBottom>
//                             Personal Info
//                         </Typography>
//                         <Grid container spacing={1}>
//                         <Grid item lg={8} md={8} xs={12}> 

//                             </Grid>

//                         </Grid>


//                     </Paper>

//                     <Paper style={styles.section}>
//                         <Typography variant="h5" gutterBottom>
//                             Family Info
//                         </Typography>
//                         <Grid container spacing={2}>
//                             <Grid item xs={7} sm={12}>
//                                 <Paper elevation={1}>
//                                     <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
//                                         <TableHead>
//                                             <TableRow>
//                                                 <TableCell>Title</TableCell>
//                                                 <TableCell align="left">Name</TableCell>
//                                                 <TableCell align="left">Age</TableCell>
//                                                 <TableCell align="left">Relation</TableCell>
//                                                 <TableCell align="left">Mobile</TableCell>
//                                             </TableRow>
//                                         </TableHead>
//                                         <TableBody>
//                                             <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                                 <TableCell component="th" scope="row">Father</TableCell>
//                                                 <TableCell align="left">Michael Doe</TableCell>
//                                                 <TableCell align="left">45</TableCell>
//                                                 <TableCell align="left">Father</TableCell>
//                                                 <TableCell align="left">+1234556789</TableCell>
//                                             </TableRow>
//                                             <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                                 <TableCell component="th" scope="row">Mother</TableCell>
//                                                 <TableCell align="left">Sarah Doe</TableCell>
//                                                 <TableCell align="left">42</TableCell>
//                                                 <TableCell align="left">Mother</TableCell>
//                                                 <TableCell align="left">+1234556790</TableCell>
//                                             </TableRow>
//                                         </TableBody>
//                                     </Table>
//                                 </Paper>
//                             </Grid>
//                         </Grid>
//                     </Paper>

//                     <Paper style={styles.section}>
//                         <Typography variant="h5" gutterBottom>
//                             Work Info
//                         </Typography>
//                         <Grid container spacing={1}>
//                             <Grid item xs={12} sm={5}>
//                                 <Typography variant="body1"><strong>Bill Type:</strong>&nbsp;Individual</Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={3}>
//                                 <Typography variant="body1"><strong>Profession:</strong>&nbsp;Service</Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={5}>
//                                 <Typography variant="body1"><strong>Job Title:</strong>&nbsp;&nbsp;Accountant</Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={5}>
//                                 <Typography variant="body1"><strong>Billing Corporate:</strong>&nbsp;&nbsp;ABC Corp</Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={5}>
//                                 <Typography variant="body1"><strong> Email:</strong>&nbsp;&nbsp;johndoe@abc.com</Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={4}>
//                                 <Typography variant="body1"><strong> Phone:</strong>&nbsp;&nbsp;+1234567891</Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={3}>
//                                 <Typography variant="body1"><strong>Last Hostel:</strong>&nbsp;&nbsp;XYZ Hostel</Typography>
//                             </Grid>
//                         </Grid>
//                     </Paper>
//                 </Container>
//             </Paper> */}
//             <Paper style={styles.page} elevation={3}>
//                 <Container maxWidth="md">
//                     <Typography variant="h4" gutterBottom align="center">
//                         Booking
//                     </Typography>
//                     {/* <Paper elevation={1} style={styles.section}>
//                         <Typography variant="h5" gutterBottom>
//                             Personal Info
//                         </Typography>
//                         <Grid container spacing={1}>
//                             <Grid item lg={8} md={8} xs={12}>

//                             </Grid>
//                         </Grid>
//                     </Paper> */}
//                     <Paper style={styles.section}>
//                         <Grid container spacing={1}>
//                             {/* Family Info Column */}

//                             <Grid item xs={12} sm={6}>
//                                 {/* <Paper style={styles.section}> */}
//                                 <Typography variant="h6" gutterBottom >
//                                     Hostel Details
//                                 </Typography>
//                                 <Grid container spacing={1}>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>Name: </strong>&nbsp;{DataObj?.PropName}</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>Address</strong>&nbsp;{DataObj?.Addr}</Typography>
//                                     </Grid>

//                                     <Grid item xs={12} sm={6}>
//                                         <Typography variant="body1"><strong>Phone:</strong>&nbsp;&nbsp;+1234567891</Typography>
//                                     </Grid>



//                                 </Grid>
//                                 {/* </Paper> */}
//                             </Grid>

//                             {/* Work Info Column */}
//                             <Grid item xs={12} sm={6}>
//                                 {/* <Paper style={styles.section}> */}
//                                 <Typography variant="h6" gutterBottom >
//                                     Booking  Info
//                                 </Typography>
//                                 <Grid container spacing={1}>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>Resident Name: </strong>&nbsp;{DataObj?.ResidentName}</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6}>
//                                         <Typography variant="body1"><strong>Book No: </strong>&nbsp;{DataObj?.BookNo}</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6}>
//                                         <Typography variant="body1"><strong>Duration:</strong>&nbsp;{DataObj?.Duration}</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6}>
//                                         <Typography variant="body1"><strong>Book From:</strong>&nbsp;{moment(DataObj?.BookDtFrom).format("MM-DD-YYYY")}</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={6}>
//                                         <Typography variant="body1"><strong>Book To:</strong>&nbsp;{moment(DataObj?.BookUpToDt).format("MM-DD-YYYY")}</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>MobileNo :</strong>&nbsp;{DataObj?.MobileNo}</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>Email :</strong>&nbsp;&nbsp;{DataObj?.Email}</Typography>
//                                     </Grid>


//                                 </Grid>
//                                 {/* </Paper> */}
//                             </Grid>

//                         </Grid>
//                     </Paper>



//                     <Paper style={styles.section}>
//                         <Grid container spacing={1}>
//                             {/* Family Info Column */}

//                             <Grid item xs={12} sm={6}>
//                                 {/* <Paper style={styles.section}> */}

//                                 <Grid container spacing={1}>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>Bill To: </strong>&nbsp;GOYAL TEX.</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>Address</strong>&nbsp;SHOP NO. L, GROUND FLOOR S.G SHAH COMPLEX OPP- HATHWA MARKET BARI PATH PATNA-800004 (BIHAR)</Typography>
//                                     </Grid>

//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>Mobile:</strong>&nbsp;&nbsp;</Typography>
//                                     </Grid>

//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>GSTIN No:</strong>&nbsp;&nbsp;10ADDPG0636Q1ZS</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>State Name  :</strong>&nbsp;&nbsp;BIHAR State Code:10</Typography>
//                                     </Grid>


//                                 </Grid>
//                                 {/* </Paper> */}
//                             </Grid>

//                             {/* Work Info Column */}
//                             <Grid item xs={12} sm={6}>
//                                 {/* <Paper style={styles.section}> */}

//                                 <Grid container spacing={1}>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>Book  To: </strong>&nbsp;GOYAL TEX.</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>Address</strong>&nbsp;SHOP NO. L, GROUND FLOOR S.G SHAH COMPLEX OPP- HATHWA MARKET BARI PATH PATNA-800004 (BIHAR)</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>Mobile :</strong>&nbsp;&nbsp;</Typography>
//                                     </Grid>

//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>GSTIN No:</strong>&nbsp;&nbsp;10ADDPG0636Q1ZS</Typography>
//                                     </Grid>
//                                     <Grid item xs={12} sm={12}>
//                                         <Typography variant="body1"><strong>State Name  :</strong>&nbsp;&nbsp;BIHAR State Code:10</Typography>
//                                     </Grid>


//                                 </Grid>
//                                 {/* </Paper> */}
//                             </Grid>

//                         </Grid>
//                     </Paper>


//                     <Paper style={styles.section}>

//                         <Typography variant="h6" gutterBottom >
//                             Room Details
//                         </Typography>
//                         <Grid container spacing={1} >
//                             <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
//                                 <TableHead>
//                                     <TableRow>

//                                         <TableCell align="left">Wing</TableCell>
//                                         <TableCell align="left">Floor</TableCell>
//                                         <TableCell align="left">Type </TableCell>
//                                         <TableCell align="left">View</TableCell>
//                                         <TableCell align="left">BedType</TableCell>
//                                         <TableCell align="left">BedNo</TableCell>
//                                         <TableCell align="left">StdRent</TableCell>
//                                         <TableCell align="left">Discount</TableCell>
//                                         <TableCell align="left">Effec_Rent</TableCell>
//                                     </TableRow>
//                                 </TableHead>
//                                 <TableBody>
//                                     <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                         <TableCell component="th" scope="row">{DataObj?.WingName}</TableCell>
//                                         <TableCell align="left">{DataObj?.FloorName}</TableCell>
//                                         <TableCell align="left">{DataObj?.RoomTypeName}</TableCell>
//                                         <TableCell align="left">{DataObj?.RoomViewNAme}</TableCell>
//                                         <TableCell align="left">{DataObj?.RoomBedTypeName}</TableCell>
//                                         <TableCell align="left">{DataObj?.RoombedName}</TableCell>
//                                         <TableCell align="left">{DataObj?.BedRent}</TableCell>
//                                         <TableCell align="left">{DataObj?.DiscAmt}</TableCell>
//                                         <TableCell align="left">{DataObj?.MonthlyAmt}</TableCell>
//                                     </TableRow>
//                                 </TableBody>
//                             </Table>
//                         </Grid>
//                         <Grid container spacing={1} >

//                         </Grid>


//                     </Paper>



//                     <Paper style={styles.section}>





//                         {/* <Typography variant="h6" gutterBottom >
//                             Coupon &  Discount.
//                         </Typography> */}

//                         {/* <Grid container spacing={1} >
//                             <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
//                                 <TableHead>
//                                     <TableRow>

//                                         <TableCell align="left">Coupon Name </TableCell>
//                                         <TableCell align="left">Disc Type</TableCell>
//                                         <TableCell align="left">Disc Amount</TableCell>
//                                         <TableCell align="left">Total Rent</TableCell>
//                                         <TableCell align="left">Net Amt</TableCell>
//                                         <TableCell align="left">Effective Rent</TableCell>
//                                     </TableRow>
//                                 </TableHead>
//                                 <TableBody>
//                                     <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                         <TableCell component="th" scope="row">081AA4A8-F</TableCell>
//                                         <TableCell align="left">LumpSum</TableCell>
//                                         <TableCell align="left">20000</TableCell>
//                                         <TableCell align="left">120000 </TableCell>
//                                         <TableCell align="left">100000</TableCell>
//                                         <TableCell align="left">10000</TableCell>
//                                     </TableRow>
//                                 </TableBody>
//                             </Table>
//                         </Grid> */}

//                         <Typography variant="h6" gutterBottom >
//                             Plan Details
//                         </Typography>


//                         <Grid container spacing={1} >

//                             <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
//                                 <TableHead>
//                                     <TableRow>

//                                         <TableCell align="left">Plan Name </TableCell>
//                                         <TableCell align="left">Tenur</TableCell>
//                                         <TableCell align="left">Free Month</TableCell>
//                                         <TableCell align="left">Adjust Month</TableCell>
//                                         <TableCell align="left">Increase(%)</TableCell>
//                                         <TableCell align="left">Deposite</TableCell>
//                                     </TableRow>
//                                 </TableHead>
//                                 <TableBody>
//                                     <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                         <TableCell component="th" scope="row">{DataObj?.PlanName}</TableCell>
//                                         <TableCell align="left">{DataObj?.PlanTenur}</TableCell>
//                                         <TableCell align="left">{DataObj?.FreeMonth}</TableCell>
//                                         <TableCell align="left">{DataObj?.LastAdjMonths} </TableCell>
//                                         <TableCell align="left">{DataObj?.IncRentPerc}</TableCell>
//                                         <TableCell align="left">{DataObj?.DepositAmt}</TableCell>
//                                     </TableRow>
//                                 </TableBody>
//                             </Table>
//                         </Grid>








//                     </Paper>
//                     <Grid container spacing={1} sx={{ marginTop: "1px", marginX: "auto", paddingX: "auto" }}>
//                         <Grid item xs={12} sm={8}>

//                         </Grid>
//                         <Grid item xs={12} sm={4} display={"flex"} justifyContent={"space-between"} >
//                             <Typography variant="body1">
//                                 <strong>Total Amount:</strong>&nbsp;&nbsp;
//                             </Typography>
//                             <Typography variant="body1" align="right" sx={{
//                                 border: 1,
//                                 borderColor: "black",
//                                 height: "30px",
//                                 width: "100px",
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                                 borderRadius: "8px",
//                                 padding: "5px",
//                                 backgroundColor: "#f5f5f5",
//                                 color: "black",
//                             }}>
//                                 {DataObj?.AdvcRcble}&nbsp;&nbsp;
//                             </Typography>
//                         </Grid>
//                         {/* <Grid item xs={12} sm={4} sx={{ display: "flex", alignItems: "center" }}>
//                             <Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
//                                 <strong>Total Amount:</strong>&nbsp;&nbsp;
//                                 <Box
//                                     sx={{
//                                         border: 1,
//                                         borderColor: "black",
//                                         height: "30px",
//                                         width: "100px",
//                                         display: "flex",
//                                         justifyContent: "center",
//                                         alignItems: "center",      
//                                         borderRadius: "8px",
//                                         padding: "5px",
//                                         backgroundColor: "#f5f5f5",
//                                         color: "black",
//                                     }}
//                                 >
//                                     23000000
//                                 </Box>
//                             </Typography>
//                         </Grid> */}


//                     </Grid>

//                     <Paper style={styles.section} elevation={2}>
//                         <Grid container spacing={1} sx={{ marginTop: "1px", marginX: "auto", paddingX: "auto" }}>
//                             <Grid item xs={12} sm={4}>
//                                 <Typography variant="body1"><strong>Bill Cycle: </strong>&nbsp;{DataObj?.BillCycle === "F" ? "First" : "Second"}</Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={4}>
//                                 <Typography variant="body1"><strong>TopDays:</strong>&nbsp;{DataObj?.Topupdays || 0}</Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={4} display={"flex"} justifyContent={"space-between"} >
//                                 <Typography variant="body1">
//                                     <strong>TopUp Amount:</strong>&nbsp;&nbsp;
//                                 </Typography>
//                                 <Typography variant="body1" align="right">
//                                     {DataObj?.TopupAmt || 0}&nbsp;&nbsp;
//                                 </Typography>
//                             </Grid>


//                             <Grid item xs={12} sm={8}>
//                                 <Typography variant="body1"><strong>Transport Plan:</strong>&nbsp;&nbsp;Transport Service</Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={4} display={"flex"} justifyContent={"space-between"} >
//                                 <Typography variant="body1">
//                                     <strong>Transport Amount:</strong>&nbsp;&nbsp;
//                                 </Typography>
//                                 <Typography variant="body1" align="right">
//                                     {DataObj?.TAmount || 0}&nbsp;&nbsp;
//                                 </Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={8}>
//                                 <Typography variant="body1"><strong>Mess Plan:</strong>&nbsp;&nbsp;Mess Service2</Typography>
//                             </Grid>
//                             <Grid item xs={12} sm={4} display={"flex"} justifyContent={"space-between"} >
//                                 <Typography variant="body1">
//                                     <strong>Mess Amount:</strong>&nbsp;&nbsp;
//                                 </Typography>
//                                 <Typography variant="body1" align="right">
//                                     {DataObj?.MAmount || 0}&nbsp;&nbsp;
//                                 </Typography>
//                             </Grid>
//                         </Grid>
//                     </Paper>










//                     <Grid container spacing={1} sx={{ marginTop: "10px", marginX: "auto", paddingX: "auto" }}>
//                         <Grid item xs={12} sm={8}>
//                             <Typography variant="body1" style={{ textDecoration: 'underline' }}>
//                                 <strong>&nbsp;Amt In Word:</strong>&nbsp;&nbsp;{DataObj?.AmtInWor}
//                             </Typography>
//                         </Grid>

//                         <Grid item xs={12} sm={4} display={"flex"} justifyContent={"space-between"}>
//                             <Typography variant="body1">
//                                 <strong>Net Amount:</strong>&nbsp;&nbsp;
//                             </Typography>
//                             <Typography
//                                 align="right"
//                                 sx={{
//                                     border: 1,
//                                     borderColor: "black",
//                                     height: "30px",
//                                     display: "flex",
//                                     justifyContent: "center",
//                                     alignItems: "center",
//                                     borderRadius: "8px",
//                                     padding: "5px",
//                                     backgroundColor: "#f5f5f5",
//                                     color: "black",
//                                     width: { xs: "100%", sm: "100px", md: "200px", lg: "300px" },

//                                     overflow: "hidden",
//                                     textOverflow: "ellipsis",
//                                     whiteSpace: "nowrap"
//                                 }}
//                             >
//                                 {DataObj?.Tamt}&nbsp;&nbsp;
//                             </Typography>
//                         </Grid>
//                     </Grid>

//                 </Container>

//             </Paper>

//         </div>
//     );
// };

// const styles = {
//     page: {
//         width: '210mm',
//         height: '280mm',
//         padding: '2mm',
//         backgroundColor: 'white',
//         margin: '10px auto',
//         boxSizing: 'border-box',
//         border: 1,
//         borderColor: "black"
//     },
//     section: {
//         padding: '8px',
//         marginBottom: '3px',
//         backgroundColor: 'white',
//         boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
//     },
// };


// export default BReport;




import React from 'react';
import moment from 'moment';

const BReport = ({ contentRef, DataObj }) => {

  return (
    <div ref={contentRef} style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', backgroundColor: 'white' }}>
      {/* Header */}
      <div style={{ marginBottom: '20px' }}>
        <h1 style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center', color: '#635bff', marginBottom: '8px' }}>Clanbridge Living Pvt Ltd</h1>
        <h2 style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center', marginBottom: '16px' }}>Booking Confirmation</h2>
      </div>

      {/* Basic Info Section */}
      <div style={{ marginBottom: '20px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
          <thead>
            <tr style={{ backgroundColor: '#635bff' }}>
              <th style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'center', color: 'white', fontWeight: 'bold' }} colSpan="4">Booking Summary</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Booking No</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.BookNo || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Book Date</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{moment(DataObj.BookDt).format('DD-MM-YYYY')}</td>
            </tr>
            <tr style={{ backgroundColor: 'white' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Mobile</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.MobileNo || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Email</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.Email || ''}</td>
            </tr>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>From Date</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{moment(DataObj.BookDtFrom).format('DD-MM-YYYY')}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>To Date</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{moment(DataObj.BookUpToDt).format('DD-MM-YYYY')}</td>
            </tr>
            <tr style={{ backgroundColor: 'white' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Duration</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.Duration || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Property Name</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.PropName || ''}</td>
            </tr>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}> Resident Name</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }} colSpan="3"> {DataObj.ResidentName || ''}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Room Details Section */}
      <div style={{ marginBottom: '20px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#635bff', marginBottom: '8px' }}>Room Details</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
          <tbody>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Wing</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.WingName || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Floor</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.FloorName || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Room Type</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.RoomTypeName || ''}</td>
            </tr>
            <tr style={{ backgroundColor: 'white' }}>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Bed No</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.RoombedName || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Bed Type</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.RoomBedTypeName || ''}</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Standard Rent</td>
              <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{DataObj.BedRent || ''}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Plan Details Section */}
      <div style={{ marginBottom: '20px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#635bff', marginBottom: '8px' }}>Plan Details</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
          <tbody>
            {[
              [
                ['Plan', DataObj.PlanName || ''],
                ['Duration', DataObj.Duration || '']
              ],
              [
                ['Free Months', DataObj.FreeMonth || '0'],
                ['Min Adv Month', DataObj.LastAdjMonths || '0']
              ],
              [
                ['Increment %', DataObj.IncRentPerc || '0'],
                ['Deposit', DataObj.DepositAmt || '']
              ],
              [
                ['Total Rent', DataObj.TotalRent || ''],
                ['Coupon Discount', DataObj.DiscAmt || 0]
              ],
              [
                ['Net Amount', DataObj.NetAmt || ''],
                ['Monthly Amount', DataObj.MonthlyAmt || '']
              ],
              [
                ['Net Payable', DataObj.AdvcRcble || ''],
                ['Discount', DataObj.MonthlyAmt * DataObj.FreeMonth || '0'],
              ]
            ].map((row, idx) => (
              <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#f9fafb' : 'white' }}>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[0][0]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{row[0][1]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[1][0]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{row[1][1]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Other Services Section */}
      <div style={{ marginBottom: '20px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#635bff', marginBottom: '8px' }}>Other Services</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
          <tbody>
            {[
              [
                ['Topup Amount', DataObj.TopupAmt || ''],
                ['Transport Service', DataObj.TAmount || '']
              ],
              [
                ['Mess Service', DataObj.MAmount || ''],
                ['Total Amount', DataObj.TotalAmt || '']
              ]
            ].map((row, idx) => (
              <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#f9fafb' : 'white' }}>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[0][0]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{row[0][1]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>{row[1][0]}</td>
                <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{row[1][1]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div style={{ marginTop: '16px', fontSize: '12px' }}>
        <p style={{ marginBottom: '4px' }}>Thank you for choosing Clanbridge Living Pvt Ltd</p>
        <p>For any queries, please contact: support@clanbridgeliving.in</p>
      </div>
    </div>
  );
};

export default BReport;
